
import { mapGetters } from 'vuex'
import ProductCard from '~/components/product-card/ProductCard'
import FullInlineBanner from '~/components/searchspring/plp-content/FullInlineBanner'
import InlineBanner from '~/components/searchspring/plp-content/InlineBanner'

export default {
  components: { ProductCard, FullInlineBanner, InlineBanner },
  computed: {
    ...mapGetters({
      vxSearchResults: 'search/getSearchResults',
      vxStoryContent: 'search/getStoryContent',
      vxIsSearching: 'search/getIsSearching',
    }),
    actualProducts() {
      return this.vxSearchResults.products.filter(
        (product) => !product.component
      )
    },
  },
  methods: {
    clickOnProduct(product) {
      const linkProduct = product?.modelGroup
        ? `/product/${product.modelGroup}?variant=${product.internal_type}-${product.internal_color_code}`
        : `/product/${product.handle}`
      this.$searchspring.events.clickProduct(
        window.location.href,
        linkProduct,
        product
      )
    },
  },
}
